import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IntlService } from '../../core/services/intl.service';
import { NgxIntlTelInputComponent, NgxIntlTelInputModule } from 'untold-ngx-intl-tel-input';
import { NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-phone-input',
    templateUrl: './phone-input.component.html',
    styleUrls: ['./phone-input.component.scss'],
    imports: [NgIf, FormsModule, ReactiveFormsModule, NgxIntlTelInputModule, TranslatePipe],
    standalone: true
})
export class PhoneInputComponent implements OnInit {
  @ViewChild('telInput', {static: false}) telInput: NgxIntlTelInputComponent;
  @Input() form: FormGroup;
  @Input() controlName: string;
  @Input() submitAttempted = false;

  public phoneNumberPreferedCountries = this.intlService.getPreferedPhoneCountries();

  constructor(private intlService: IntlService) { }

  ngOnInit() {
  }
}
